// eslint-disable-next-line no-shadow
export enum HotelAvailable {
    none = 0,
    all = 1,
    byRequest = 2,
}
export type THotelAvailable = HotelAvailable.none | HotelAvailable.all | HotelAvailable.byRequest;